import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "./ui/dialog";
import { Sparkles } from "lucide-react";
import BookingWidget from "./BookingWidget";

export default function BookingModal() {
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const h = () => setOpen(true);
    window.addEventListener("bf-open-booking", h);
    return () => window.removeEventListener("bf-open-booking", h);
  }, []);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent
        data-testid="booking-modal"
        className="max-w-3xl border-none p-0 overflow-hidden bg-[#F7F5F0] rounded-2xl max-h-[92vh] overflow-y-auto"
      >
        <div className="bg-[#0B192C] text-white px-8 py-7 relative overflow-hidden">
          <div className="absolute -right-6 -top-6 w-32 h-32 rounded-full bg-[#D4AF37]/10 blur-2xl" />
          <p className="overline text-[#D4AF37] mb-2 flex items-center gap-2">
            <Sparkles size={14} /> Book Direct
          </p>
          <DialogTitle className="font-serif text-4xl leading-none font-normal">Plan Your Stay</DialogTitle>
          <DialogDescription className="text-white/60 text-sm mt-2">
            Choose your dates and we'll open live availability on our secure booking engine — no fees, ever.
          </DialogDescription>
        </div>
        <div className="p-6">
          <BookingWidget onSubmitted={() => setOpen(false)} />
        </div>
      </DialogContent>
    </Dialog>
  );
}
